var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditManually(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.5V21H4.5V3H12V1.5H4.5C3.67125 1.5 3 2.17125 3 3V21C3 21.8288 3.67125 22.5 4.5 22.5H16.5C17.3287 22.5 18 21.8288 18 21V16.5H16.5Z",
    fill: "url(#paint0_linear_545_10417)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.17 6.85856L17.142 4.83056L18.8422 3.13031L20.8702 5.15831L19.17 6.85856ZM11.0287 14.9998H9.00073V12.9718L16.0815 5.89106L18.1095 7.91906L11.0287 14.9998ZM22.1535 4.31981L19.6807 1.84706C19.218 1.38431 18.4635 1.38431 18.0007 1.84706L7.50073 12.3501V16.4998H11.6505L22.1535 5.99981C22.6162 5.53706 22.6162 4.78256 22.1535 4.31981Z",
    fill: "url(#paint1_linear_545_10417)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_545_10417",
    x1: 3.35714,
    y1: 1.35158,
    x2: 23.8039,
    y2: 14.2674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64B6AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77D9CD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_545_10417",
    x1: 7.85787,
    y1: 1.39399,
    x2: 23.9094,
    y2: 15.5892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64B6AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#77D9CD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditManually);
export default __webpack_public_path__ + "static/media/edit-manually.684e2abfe1e563803df899df2d7295b2.svg";
export { ForwardRef as ReactComponent };